import { render, staticRenderFns } from "./DriverList.vue?vue&type=template&id=50054ade&scoped=true&"
import script from "./DriverList.vue?vue&type=script&lang=js&"
export * from "./DriverList.vue?vue&type=script&lang=js&"
import style0 from "./DriverList.vue?vue&type=style&index=0&id=50054ade&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50054ade",
  null
  
)

export default component.exports